import { useContext } from 'react';
import { ProductContext, ProductContextProps } from 'src/providers/ProductContextProvider';

export const useProductContext = (): ProductContextProps => {
  return useContext(ProductContext);
};
